import React from "react";
import { EventStatus } from "@prestosports/prestostats-core/Common";
import Grid from "@material-ui/core/Grid";
import LineScore from "./LineScore";
import DriveSummary from "./DriveSummary";
import TeamComparison from "./TeamComparison";
import ScoreBoard from "./ScoreBoard";
import { toDisplayMs } from "../../football/components/utils/PlayUtils";

const BoxScore = ({ boxScore, expanded = false }) => {
	const { gameContext, awayTeam, homeTeam, game, event } = boxScore;
	const { sportCode } = game;
	const { venue, startDateTime } = event;
	const { swapTeams, currentPeriod, gameClock, score, gameConfig } = gameContext;
	const [homeScore, visitorScore] = score || [0, 0];
	// Serialized payload: now is a number (canonical countdown ms).
	const now = toDisplayMs(
		typeof gameClock?.now === "function" ? gameClock.now() : gameClock?.now,
		gameConfig,
		currentPeriod
	);
	const isFinal = EventStatus.isFinal(event);

	return (
		<Grid container spacing={3}>
			<Grid item lg={12} md={12} sm={12} xs={12}>
				<ScoreBoard
					swapTeams={swapTeams}
					awayTeam={awayTeam}
					awayScore={visitorScore}
					homeTeam={homeTeam}
					homeScore={homeScore}
					startDateTime={startDateTime}
					venue={venue}
					periodNumber={currentPeriod}
					time={now}
					isFinal={isFinal}
					sportId={sportCode}
				/>
			</Grid>
			<Grid item lg={12} md={12} sm={12} xs={12}>
				<LineScore boxScore={boxScore} />
			</Grid>
			<Grid item lg={12} md={12} sm={12} xs={12}>
				<DriveSummary boxScore={boxScore} expanded={expanded} />
			</Grid>
			<Grid item lg={12} md={12} sm={12} xs={12}>
				<TeamComparison boxScore={boxScore} expanded={expanded} />
			</Grid>
		</Grid>
	);
};

export default BoxScore;
